import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'

@Injectable({ providedIn: 'root' })
export class IframeResizeService {
  sendHeightMessage() {
    const pass_data = {
      contentheight: document.body.scrollHeight,
    }
    window.parent.postMessage(JSON.stringify(pass_data), environment.parentOrigin)
  }

  sendHeightMessageOnResize() {
    const observer = new ResizeObserver(() => {
      this.sendHeightMessage()
    })
    observer.observe(document.body)
  }
}
